import React from 'react';
import { Chip } from '@material-ui/core';

import { ENTITY_TYPES_TO_ICONS, SELECTOR_TYPE } from './selectorsConsts';
import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';

import upload_file_blue from '../../../common/Images/upload_file_blue.svg';

import styles from './css/SelectedEntitiesContainer.module.css';
import { allComputersResource, unresolvedResources } from '../../../Policy/common';
import { Tooltip } from '@silverfort/sf-components';

const ImportFromFileButton = ({ onFileUploaded, excluded, fileLoading }) => {
    const componentId = `ImportFromFileButton_${excluded}`;
    return (
        //TODO: replace with new components package when implemented
        <div className={styles.uploadFileButton}>
            <label htmlFor={componentId}>
                <img src={upload_file_blue} alt="" />
                <div className={styles.text}>Upload file</div>
            </label>
            <input
                type="file"
                id={componentId}
                accept=".csv"
                multiple={false}
                disabled={fileLoading}
                onChange={(e) => {
                    onFileUploaded(e.target.files[0], excluded);
                }}
                onClick={(e) => {
                    e.target.value = null; // In order to allow upload same file twice
                }}
            />
        </div>
    );
};

const unresolvedResourcesTooltipLabel = "Refers to servers not detected by Silverfort, which may indicate that AD Sync has not yet been performed."

const ChipLabel = ({selectedEntity, chipLabel}) => {
    const chipLabelElement = (<div className={styles.customChipContainer}>
        <div className={styles.imageContainer}>
            <img src={ENTITY_TYPES_TO_ICONS[selectedEntity.type]} alt="" />
        </div>
        <div className={styles.textContainer}>
            <div className={styles.header}>{chipLabel}</div>
            <div className={styles.desc}>{selectedEntity.domain_name}</div>
        </div>
    </div>)
    if (selectedEntity.guid === unresolvedResources.guid) {
        return <Tooltip title={unresolvedResourcesTooltipLabel}>
            {chipLabelElement}
        </Tooltip>
    }
    return chipLabelElement

}

const SelectedEntitiesContainer = ({
    selectedEntities,
    onRemoveSelected,
    selectorType,
    focusedResource,
    onResourceClicked,
    applyAllMsg,
    removeIncludedBlocked,
    removeExcludedBlocked,
    selectAllEntities,
    selectAllText,
    onFileUploaded,
    fileLoading,
    showExcluded,
    showSelected = true
}) => {
    if (!selectedEntities) {
        return;
    }

    let includedChips = [];
    let excludedChips = [];
    for (const entityIndex in selectedEntities) {
        const selectedEntity = selectedEntities[entityIndex];

        if (selectAllEntities && !selectedEntity.excluded) {
            continue;
        }
        const name = selectedEntity.name ? selectedEntity.name : selectedEntity.identifier;

        let chipId = selectedEntity.guid ? `chip_${selectedEntity.guid}` : `chip_${name}`;
        let chipTitle = selectedEntity.path
            ? `${selectedEntity.path} ${selectedEntity.domain_name ? ' (' + selectedEntity.domain_name + ')' : ''}`
            : name;
        let chipLabel = selectedEntity.display_name || name;
        if (selectedEntity.is_deleted) {
            chipLabel = `${chipLabel} (deleted)`;
        }
        if (selectedEntity.is_disabled) {
            chipLabel = `${chipLabel} (disabled)`;
        }
        let chipClassNames = '';
        let onChipClicked = () => { };
        if (selectedEntity.type === AD_ENTITY_TYPES.IP && selectedEntity.address) {
            const fullIpAddr =
                selectedEntity.mask === '32'
                    ? selectedEntity.address
                    : `${selectedEntity.address}/${selectedEntity.mask}`;
            chipTitle = '';
            chipId = `chip_${fullIpAddr}`;
            chipLabel = fullIpAddr;
        }
        if (selectorType === SELECTOR_TYPE.RESOURCE) {
            chipClassNames = selectedEntity.guid === focusedResource.guid ? styles.focusChip : '';
            onChipClicked = () => onResourceClicked(selectedEntity);
        }

        let onDelete = undefined;
        if (
            ((selectedEntity.excluded && !removeExcludedBlocked) ||
                (!selectedEntity.excluded && !removeIncludedBlocked)) && selectedEntity.guid !== allComputersResource.guid
        ) {
            onDelete = () => onRemoveSelected(entityIndex, selectedEntity);
        }
        const entityChip = (
            <Chip
                className={chipClassNames}
                title={chipTitle}
                key={chipId}
                id={chipId}
                variant="outlined"
                deleteIcon={<i className="fa fa-times"></i>}
                onDelete={onDelete}
                label={
                    <ChipLabel selectedEntity={selectedEntity} chipLabel={chipLabel} />
                }
                clickable={selectorType === SELECTOR_TYPE.RESOURCE}
                onClick={onChipClicked}
            />
        );
        selectedEntity.excluded ? excludedChips.push(entityChip) : includedChips.push(entityChip);
    }
    if (selectAllEntities) {
        const chipId = 'AllUsersAndGroups';
        const chipLabel = 'All ' + (selectAllText || 'entities');
        const entityChip = (
            <Chip
                className={styles.disablesChipContainer}
                title={chipId}
                key={chipId}
                id={chipId}
                variant="outlined"
                label={
                    <div className={styles.customChipContainer}>
                        <div className={styles.textContainer}>
                            <div className={styles.header} title={chipLabel}>
                                {chipLabel}
                            </div>
                        </div>
                    </div>
                }
            />
        );

        includedChips.push(entityChip);
    }
    const getSortedEntitiesChips = (chipsList) => {
        return chipsList.sort(function (first, second) {
            return first.props.label < second.props.label ? -1 : first.props.label > second.props.label ? 1 : 0;
        });
    };
    includedChips = getSortedEntitiesChips(includedChips);
    excludedChips = getSortedEntitiesChips(excludedChips);

    return (
        <div className={styles.selectedContainer}>
            {showSelected && (
                <>
                    <div className={styles.selectedTitle}>
                        Selected
                        {applyAllMsg && applyAllMsg.text && !applyAllMsg.isExclude && (
                            <div className={styles.applyAllMsg}> {applyAllMsg.text} </div>
                        )}
                        {onFileUploaded && (
                            <ImportFromFileButton
                                onFileUploaded={onFileUploaded}
                                excluded={false}
                                fileLoading={fileLoading}
                            />
                        )}
                    </div>
                    <div className={styles.selectedData}>
                        <div className={styles.selectedDataBody}>{includedChips}</div>
                    </div>
                </>
            )}
            {showExcluded && (
                <>
                    <div className={styles.selectedTitle}>
                        Excluded
                        {applyAllMsg && applyAllMsg.text && applyAllMsg.isExclude && (
                            <div className={styles.applyAllMsg}> {applyAllMsg.text} </div>
                        )}
                        {onFileUploaded && (
                            <ImportFromFileButton
                                onFileUploaded={onFileUploaded}
                                excluded={true}
                                fileLoading={fileLoading}
                            />
                        )}
                    </div>
                    <div className={styles.selectedData}>
                        <div className={styles.selectedDataBody}>{excludedChips}</div>
                    </div>
                </>
            )}
        </div>
    );
};

export default SelectedEntitiesContainer;
